import React from "react";
// import villageCampaignImg from "../../../Assets/Images/about/villageCampaignImg.png";
import about_village_1 from "../../../Assets/Images/about/about_village_1.png";
import AboutHeadings from "./AboutHeadings";

const approachSections = [
  {
    title: "Action & Reflection",
    desc: "Participatory work with community and learn to create model.",
  },
  {
    title: "Action & Reflection",
    desc: "Doing issues based research and influence policy in favor of marginalized community.",
  },
  {
    title: "Model Replication",
    desc: "Extensive Partnership with stakeholders, CSOs, PRI & CBOs for wider replication of success model for maximization of impact.",
  },
];

const AboutOurApproach = () => {
  return (
    <div className="sm:py-6 xl:py-10 px-4 md:px-[5rem]">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        {/* Content */}
        <div className="col-span-1 mt-8 lg:mt-0">
          <AboutHeadings title={"Our Approach"} textAlign="left" />

          <p
            className="text-sm md:text-base leading-relaxed text-[#555] text-justify tracking-wide mt-4"
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            AAFSA approach is holistic. It has the ability to adapt to changing
            development context, which makes it unique and has sustained it for
            more than one decade. It supports government in terms of effective
            implementation of different development schemes and ensures public
            participation in monitoring and evaluation of the program. It also
            builds evidence at community level through research to advocate for
            pro-poor policy. We believe in partnership for exchanging ideas,
            supporting resources, and consulting with stakeholders to maximize
            impact in a short span of time with limited funds.
          </p>

          <div className="mt-6 space-y-6">
            {approachSections.map((section, idx) => (
              <div
                key={idx}
                data-aos="fade-up"
                data-aos-duration="1000"
                data-aos-delay={idx * 200} // stagger animation
              >
                <h3 className="leading-[30px] tracking-[0.5px] text-[#0094BB] font-medium text-lg mb-1">
                  {section.title}
                </h3>
                <p className="text-[#585858] text-sm md:text-base text-justify leading-[150%] tracking-[0.5%]">
                  {section.desc}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Image */}
        <div
          className="col-span-1 lg:mt-20 xl:mt-0  text-right"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          <img
            src={about_village_1}
            alt="Our Approach"
            className="rounded-lg w-full max-h-[35rem] shadow-lg transform transition-transform duration-500 hover:scale-105"
          />
        </div>
      </div>
    </div>
  );
};

export default AboutOurApproach;
